var scope_0 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/0ac97811020e6b8382f96b3b5acf78c1.js').default;
var scope_1 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/213b0ecbcbc331223e193304a25fcdd6.js').default;
var scope_2 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2202c802bc6a492ba60bf87f14afb932.js').default;
var scope_3 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/aaa87850994929372b8f1485ab0ad8c7.js').default;
var scope_4 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ace3c453ca6cb515a74002e7c665272e.js').default;
var scope_5 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b5a431fe4017349f702f931aa58df1c6.js').default;
var scope_6 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d11b416f52e0c898bde2444b595178e7.js').default;
var scope_7 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_8 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fcd4a4e33b6f787899f279cdd8253f55.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8 )
    